// src/ui/design-system/colors.ts
//
// デザインコンセプト:「計測器の静けさ、スコアの熱」
// 暗いラボ機材のような落ち着いたベースに、スコア/警告だけが暖色で発光する。
// 0.1節の「表の単純さ / 裏の複雑さ」の対比を、配色の情報量差でも表現する
// (通常UIは彩度を抑え、Xレイモード起動時だけ多色の計測データが浮かび上がる)。

export const colors = {
  // ベース(落ち着いたダークネイビー階調)
  bg: "#0B0F19",
  bgElevated: "#12172A",
  surface: "#1A2036",
  surfaceBorder: "#2A3352",

  // テキスト
  textPrimary: "#F1F5F9",
  textSecondary: "#94A3B8",
  textMuted: "#5B6584",

  // 暖色系スコアバッジ(18章で明示された方針)
  amber: "#F59E0B",
  amberStrong: "#F97316",

  // リスクレベル(色以外の記号(○/△/×)と併用すること — 2.3節アクセシビリティ)
  safe: "#34D399",
  caution: "#FBBF24",
  danger: "#F87171",

  // Xレイモード専用: 計測データの多色性を表現する寒色〜中間色パレット
  xray: {
    covariance: "#38BDF8",
    forceVector: "#F97316",
    lumbarReadout: "#FB7185",
    label: "#94A3B8",
  },
} as const;

export type ColorToken = keyof typeof colors;
